import { useCallback, useEffect, useState } from "react";
import { api } from "../../../../utils/api";
import Input from "../../../common/input/Input";

export default function FieldOwner({ ownerProfileId, onChange }) {
	const [query, setQuery] = useState("");
	const [doctors, setDoctors] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");

	const fetchDoctors = useCallback(() => {
		setIsLoading(true);
		setErrorMessage("");
		api.doctorSearch({
			query: query,
			page: 1,
		}).then((result) => {
			setDoctors(result.doctors || []);
			setIsLoading(false);
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}, [query]);

	useEffect(() => {
		const timeout = setTimeout(() => {
			fetchDoctors();
		}, 300);

		return () => clearTimeout(timeout);
	}, [fetchDoctors]);

	return (
		<div className="flex flex-col gap-3">
			<Input
				onChange={(e) => setQuery(e.target.value)}
				value={query}
				label={"جستجوی درمانگر"}
				placeholder={"نام درمانگر"}
			/>
			<div className="relative">
				<label className="absolute right-4 -top-2.5 bg-white px-[4px] text-midGray font-Vazir-400 text-sm">
					مالک وبینار
				</label>
				<select
					value={ownerProfileId}
					onChange={(e) => onChange(e.target.value)}
					className="w-full font-Vazir-400 rounded-[10px] border border-midGray px-[16px] pt-[8px] pb-[4px] text-[#444444] focus:outline-none focus:border-[#444444] bg-white"
				>
					<option value="">
						{isLoading ? "در حال دریافت درمانگران..." : "انتخاب درمانگر"}
					</option>
					{doctors.map((doctor) => (
						<option key={doctor.id} value={doctor.id}>
							{doctor.name || doctor.phone_number || `درمانگر ${doctor.id}`}
						</option>
					))}
				</select>
			</div>
			{errorMessage && (
				<div className="text-center font-Vazir-400 text-[#cc0000]">{errorMessage}</div>
			)}
		</div>
	);
}
